module.exports = __webpack_public_path__ + "static/media/abl.7392d181.png";